"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hydrateProducts = exports.removeLiveDataFromProducts = void 0;
const fluture_1 = require("fluture");
const monet_1 = require("monet");
const products_1 = require("../commercetools/products");
const productTypes_1 = require("../commercetools/productTypes");
const config_1 = require("../config");
/**
 * The initial store should not contain any discounts or out of stock information since these are loaded in real time.
 */
const removeLiveDataFromProducts = (enable) => (products) => {
    return enable
        ? products.map((v) => ({
            ...v,
            discountedPrice: (0, monet_1.None)(),
            discountedPriceWithServicePlan: (0, monet_1.None)(),
            restockDate: undefined,
        }))
        : products;
};
exports.removeLiveDataFromProducts = removeLiveDataFromProducts;
/**
 * A request to return products for the locale filtered by product types.
 * This data can be used to hydrate the redux store.
 */
const hydrateProducts = (removeLiveData = true) => (0, productTypes_1.commercetoolsRequestProductTypes)()
    .pipe((0, fluture_1.map)(productTypes_1.formatProductTypeResponse))
    .pipe((0, fluture_1.chain)(productTypes => (0, products_1.commercetoolsRequestProducts)(config_1.locale)
    .pipe((0, fluture_1.map)(products_1.formatProductResponse))
    .pipe((0, fluture_1.chain)(_products => _products.cata(fluture_1.reject, fluture_1.resolve)))
    .pipe((0, fluture_1.map)((0, productTypes_1.updateProductsWithTypes)(productTypes)))
    .pipe((0, fluture_1.map)(productTypes_1.filterOutChildTypes))
    .pipe((0, fluture_1.map)((0, exports.removeLiveDataFromProducts)(removeLiveData)))));
exports.hydrateProducts = hydrateProducts;
//# sourceMappingURL=hydrate.js.map